var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"required-fields"},[_c('span',{staticClass:"required-mark"},[_vm._v("*")]),_vm._v(" Denotes required fields")])}]

export { render, staticRenderFns }